export const AbortSteps = Symbol('[[AbortSteps]]');
export const ErrorSteps = Symbol('[[ErrorSteps]]');
export const CancelSteps = Symbol('[[CancelSteps]]');
export const PullSteps = Symbol('[[PullSteps]]');
